<template>
  <footer class="w-full min-w-rs-header h-[60px] bg-rs-footer">
    <div class="rs-footer w-rs-content h-full flex items-center mx-auto">
      <RsButton
        :href="config.freidokBaseUrl + '/site/legal'"
        fill="link"
        size="link"
        class="mx-auto text-rs-primary"
      >
        {{ t("fdt:ui:legal") }}
      </RsButton>
      <RsButton
        :to="{ name: 'Site', params: { type: 'contact' } }"
        fill="link"
        size="link"
        class="mx-auto text-rs-primary"
      >
        {{ t("fdt:ui:contact") }}
      </RsButton>
      <RsButton
        :to="{ name: 'Site', params: { type: 'imprint' } }"
        fill="link"
        size="link"
        class="mx-auto text-rs-primary"
      >
        {{ t("fdt:ui:imprint") }}
      </RsButton>
    </div>
  </footer>
</template>

<script setup lang="ts">
import useConfig from "@/composables/config";
import { useI18n } from "vue-i18n";
import RsButton from "@/components/base/RsButton.vue";

const { t } = useI18n({ useScope: "global" });
const { config } = useConfig();
</script>
